import 'core-js/modules/es.object.assign.js';
import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';

var VisuallyHidden = function VisuallyHidden(_a) {
  var children = _a.children,
    rest = __rest(_a, ["children"]);
  return jsx("div", Object.assign({
    className: "cogs-visually-hidden"
  }, rest, {
    "aria-hidden": "true",
    children: children
  }));
};

export { VisuallyHidden };
